import React from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { changeShowModal } from '../../../store/actions/SideMenu';
import { PrivateRoutes } from '../../../utils/constants/routes';
import { popUp } from '../../../utils/helpersFunction';
import { Button } from '../../FormComponents/Button/Button';
import s from './ModalDeleteFeedback.module.scss';

export const ModalDeleteFeedback = ({...props}) => {
  const {otherParams} = props;
  const dispatch = useDispatch();
  const history = useHistory();

  const onBackFacility = () => {
    dispatch(
      changeShowModal({
        nameModal: 'deleteFeedback',
        stateModal: false,
        otherParams: undefined,
      }),
    );
  };

  const goFeedbackPage = (otherParams: any) => {
    const {deleteFunc, id} = otherParams;

    deleteFunc({id: id}).then(async () => {
      popUp({
        props: 'The action was successful',
        type: 'success',
        isCustomMessage: true,
      });
      await dispatch(
        changeShowModal({
          nameModal: 'deleteFeedback',
          stateModal: false,
          otherParams: undefined,
        }),
      );
      await history.push(PrivateRoutes.feedbacks.list);
    });
  };

  return (
    <div className={s.modalBox}>
      <div className={s.title}>
        {' '}
        Are you sure you want to delete Feedback Page?{' '}
      </div>
      <div className={s.description}>
        This Feedback page will be deleted immediately. You can not undo this
        action
      </div>
      <div className={s.control}>
        <Button
          text="No, Cancel"
          type="submit"
          onClick={() => onBackFacility()}
          class_type="secondary"
        />
        <Button
          text="Yes, Delete Feedback Page"
          type="submit"
          onClick={() => goFeedbackPage(otherParams)}
          class_type="main"
        />
      </div>
    </div>
  );
};
